// POA Pricing

;(function () {
  function submitPriceRequestFormData(e) {
    e.preventDefault();
    var button = $(e.target);
    var form = $('#price-request-form');
    var formMessage = form.find('.form-message');
    var postData = form.serializeArray();
    formMessage.html('');

    var postData = $('#price-request-form').serializeArray();

    // Validate name
    var name = postData.find(x=> x.name == 'name');
    if(name.value == '') {
      formMessage.html('Name is required.')
      return false;
    }

    // Validate company
    var company = postData.find(x=> x.name == 'company');
    if(company.value == '') {
      formMessage.html('Company is required.')
      return false;
    }
    
    //Validate phone
    var phone = postData.find(x=> x.name == 'phone');
    if (!/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(phone.value))
    {
      formMessage.html('Not valid phone')
      return false;
    }

    // Validate email
    var email = postData.find(x=> x.name == 'email');
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email.value))
    {
      formMessage.html('Not valid email')
      return false;
    }

    // Validate quantity
    var quantity = postData.find(x=> x.name == 'quantity');
    if(quantity && (quantity.value == '' || quantity.value <= 0)) {
      formMessage.html('Quantity is required.')
      return false;
    }
    
    button.html("Submitting...");
    button.attr('disabled', true)
    sendContactAPI(postData, form, button)
  }

  function sendContactAPI (rawData, form, button) {
    $.post(
      `https://chorleydigital.com/api/bearingking/mail.php`,
      rawData,
      function (res) {
        let result = JSON.parse(res)
        if (result.success) {
          const successMessage = form.find('#success_message').val()
          let formMessage = form.find('.form-message')
          formMessage.html(`${successMessage}`)
          formMessage.addClass('message--success')

          form.find('.form-data').addClass('hide')
          form[0].reset()
          button.html('Submit')
          button.removeAttr('disabled')
        }
      }
    )
  }

  const submitPriceRequestButton = document.querySelector(
    '#price-request-button'
  )
  console.log('submitPriceRequestButton', submitPriceRequestButton)
  if (submitPriceRequestButton) {
    submitPriceRequestButton.addEventListener(
      'click',
      submitPriceRequestFormData
    )
  }
})()
